import React from 'react';
import Header from '../components/header';
import Footers from '../components/footers';
import { Card } from 'flowbite-react';
import { IoIosTimer } from "react-icons/io";
import { BsSearch } from "react-icons/bs";
import { PiVideo } from "react-icons/pi";
import { useTranslation } from 'react-i18next';

const Features = () => {
    const { t } = useTranslation();

    const cardsFeatures = [
        {
            id: 1,
            title: t('features.cards.topic_input.title'),
            description: t('features.cards.topic_input.description')
        },
        {
            id: 2,
            title: t('features.cards.course_type.title'),
            description: t('features.cards.course_type.description')
        },
        {
            id: 3,
            title: t('features.cards.ai_generation.title'),
            description: t('features.cards.ai_generation.description')
        },
        {
            id: 4,
            title: t('features.cards.learning_styles.title'),
            description: t('features.cards.learning_styles.description')
        },
        {
            id: 5,
            title: t('features.cards.personalized_curriculum.title'),
            description: t('features.cards.personalized_curriculum.description')
        },
        {
            id: 6,
            title: t('features.cards.realtime_preview.title'),
            description: t('features.cards.realtime_preview.description')
        },
        {
            id: 7,
            title: t('features.cards.create_quizzes.title'),
            description: t('features.cards.create_quizzes.description')
        },
        {
            id: 8,
            title: t('features.cards.question_input.title'),
            description: t('features.cards.question_input.description')
        },
        {
            id: 9,
            title: t('features.cards.quiz_type.title'),
            description: t('features.cards.quiz_type.description')
        },
        {
            id: 10,
            title: t('features.cards.ai_quiz.title'),
            description: t('features.cards.ai_quiz.description')
        },
        {
            id: 11,
            title: t('features.cards.personalized_quiz.title'),
            description: t('features.cards.personalized_quiz.description')
        },
        {
            id: 12,
            title: t('features.cards.quiz_preview.title'),
            description: t('features.cards.quiz_preview.description')
        },
        {
            id: 13,
            title: t('features.cards.ai_assistant.title'),
            description: t('features.cards.ai_assistant.description')
        },
        {
            id: 14,
            title: t('features.cards.task_management.title'),
            description: t('features.cards.task_management.description')
        },
        {
            id: 15,
            title: t('features.cards.instant_answers.title'),
            description: t('features.cards.instant_answers.description')
        },
        {
            id: 16,
            title: t('features.cards.ai_planning.title'),
            description: t('features.cards.ai_planning.description')
        },
        {
            id: 17,
            title: t('features.cards.personalized_guidance.title'),
            description: t('features.cards.personalized_guidance.description')
        },
        {
            id: 18,
            title: t('features.cards.seamless_integration.title'),
            description: t('features.cards.seamless_integration.description')
        },
        {
            id: 19,
            title: t('features.cards.realtime_updates.title'),
            description: t('features.cards.realtime_updates.description')
        }
    ];

  

    const cardBenefit = [
        {
            id: 1,
            title: t('features.benefits.time_efficiency.title'),
            description: t('features.benefits.time_efficiency.description'),
            icon: <IoIosTimer className="text-xl max-md:text-lg dark:text-white" />
        },
        {
            id: 2,
            title: t('features.benefits.ai_enhanced.title'),
            description: t('features.benefits.ai_enhanced.description'),
            icon: <BsSearch className="text-xl max-md:text-lg dark:text-white" />
        },
        {
            id: 3,
            title: t('features.benefits.interactive_learning.title'),
            description: t('features.benefits.interactive_learning.description'),
            icon: <PiVideo className="text-xl max-md:text-lg dark:text-white" />
        }
    ];

    // Modified style with responsive widths
    const style = {
        "root": {
            "base": "flex rounded-none border border-black bg-white shadow-none dark:border-white dark:bg-black m-2 md:m-4 w-full sm:w-[calc(50%-1rem)] md:w-[calc(33.333%-2rem)] lg:w-[calc(25%-2rem)]",
            "children": "flex h-full flex-col justify-center gap-3 p-3 md:p-5",
            "horizontal": {
                "off": "flex-col",
                "on": "flex-col"
            },
            "href": "hover:bg-white dark:hover:bg-black"
        },
        "img": {
            "base": "",
            "horizontal": {
                "off": "rounded-none",
                "on": "rounded-none"
            }
        }
    };

    // Modified style for "How It Works" section with responsive adjustments
    const styleTwo = {
        "root": {
            "base": "flex rounded-none bg-white shadow-none dark:bg-black m-2 md:m-4 w-full sm:w-[calc(50%-1rem)] md:max-w-xs",
            "children": "flex h-full flex-col justify-center gap-3 p-3 md:p-5",
            "horizontal": {
                "off": "flex-col",
                "on": "flex-col"
            },
            "href": "hover:bg-white dark:hover:bg-black"
        },
        "img": {
            "base": "",
            "horizontal": {
                "off": "rounded-none",
                "on": "rounded-none"
            }
        }
    };

    return (
        <div className='min-h-screen flex flex-col'>
            <Header isHome={false} className="sticky top-0 z-50" />
            <div className='dark:bg-black flex-1'>
                {/* Features Section */}
                <div className='px-4 md:px-8 py-12 md:py-16'>
                    <div className='text-center mb-10 md:mb-16'>
                        <h1 className="text-4xl md:text-6xl font-black dark:text-white">
                            {t('features.title')}
                        </h1>
                        <p className="text-center text-black mt-4 max-w-2xl mx-auto font-medium text-sm md:text-base dark:text-white">
                            {t('features.subtitle')}
                        </p>
                    </div>
                    <div className='flex flex-wrap justify-center'>
                        {cardsFeatures.map((card) => (
                            <Card key={card.id} theme={style}>
                                <h5 className='text-lg md:text-xl font-black tracking-tight text-black dark:text-white'>
                                    {card.title}
                                </h5>
                                <p className='font-normal text-xs md:text-sm text-black dark:text-white'>
                                    {card.description}
                                </p>
                            </Card>
                        ))}
                    </div>
                </div>

                {/* Benefits Section */}
                <div className='px-4 md:px-8 py-12 md:py-16 bg-gray-50 dark:bg-black'>
                    <div className='text-center mb-10 md:mb-16'>
                        <h2 className="text-3xl md:text-4xl font-black dark:text-white">
                            {t('features.benefits_title')}
                        </h2>
                    </div>
                    <div className='flex flex-wrap justify-center gap-4 md:gap-8'>
                        {cardBenefit.map((card) => (
                            <Card key={card.id} className="w-full sm:w-64 md:w-80" theme={style}>
                                <div className="mb-2">{card.icon}</div>
                                <h5 className='text-lg md:text-xl font-black tracking-tight text-black dark:text-white'>
                                    {card.title}
                                </h5>
                                <p className='font-normal text-xs md:text-sm text-black dark:text-white'>
                                    {card.description}
                                </p>
                            </Card>
                        ))}
                    </div>
                </div>

              
            </div>
            <Footers className="sticky bottom-0 z-50" />
        </div>
    );
};

export default Features;